import signedFetch from './util/signedFetch.js';

export default newUserEmail =>
  signedFetch('editCurrentUserDetails', `${__API_BASE__}/user/edit`, 'POST', { newUserEmail });
